module.exports = __webpack_public_path__ + "static/media/processSuccess.eb8b7db6.png";